import { useEffect } from 'react';
import useAdFree from '../hooks/useAdFree';

type Props = Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'id'> & {
    id: string;
};

export function FuseZone(props: Props) {
    const shouldMount = !useAdFree();

    useEffect(() => {
        if (!shouldMount) return;
        window.fusetag.que.push(() => {
            window.fusetag.registerZone(props.id);
        });

        return () => {
            window.fusetag.que.push(() => {
                window.fusetag.destroyZone(props.id);
            });
        };
    }, [props.id, shouldMount]);

    if (!shouldMount) return;
    return <div {...props} data-fuse={props.id} />;
}
